module.exports = __webpack_public_path__ + "static/img/egg_g_11.efe3ebb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_11.png
// module id = vW6A
// module chunks = 1